module.exports = __webpack_public_path__ + "img/peerspectives-bg-m.d3b715fe.png";